<aurora-modal
        [open]="true"
        headline="{{ title }}"
        primaryAction="OK"
        (close)="cancel.emit()">
    <ep-panel panelType="transparent">
        <ep-row>
            <div
                class="col-12"
                style="display: inline-block; max-width: 100%; margin-bottom: 10px; white-space: pre-line"
            >
                {{ message }}
            </div>
        </ep-row>
    </ep-panel>

    <div slot="footer">
        <aurora-button id="PrimaryButton" variant="primary" (click)="confirm.emit()">{{ btnOkText }}</aurora-button>
    </div>
</aurora-modal>